import React from 'react';
import { Form } from 'src/components/Antd';
import Co from 'src/constrains/AdvancedFilters/Collapse';
import { RegisteredSalesChannel } from 'src/constrains/AdvancedFilters/Components';
import { ESalesChannelRadioType } from 'src/constrains/AdvancedFilters/Components/RegisteredSalesChannel';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const Item = Form.Item;

// // import { get } from 'lodash';
//import { formGetValue } from 'src/tools/helper';

const _RegisteredSalesChannel = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { form, name, defaultState, radioName, options, title, ...rest } =
    props;
  return (
    <Item
      noStyle
      shouldUpdate={(p, c) => {
        const touched = form.isFieldTouched(radioName);
        // const cv = formGetValue(c, name);
        // const pv = formGetValue(p, name);
        // console.log(p, c);

        return touched; //|| cv !== pv;
      }}>
      {(f) => {
        const { getFieldValue } = f;
        const handleOnClose = () => {
          form
            .validateFields([name])
            .then((r) => {
              console.log('right', r);
              ////console.log('没错');
            })
            .catch((r) => {
              console.log('error', r);
              const { errorFields } = r;
              if ((errorFields || []).length > 0)
                form.setFieldsValue(defaultState);
            });
        };

        const selectedUuid = getFieldValue(name) || [];
        const selectPromotion = selectedUuid.map((i) => {
          const item = options.find((option) => {
            return option.value === i;
          });
          if (item) {
            return item.label;
          }
          return '';
        });
        const hasData = getFieldValue(radioName);

        const prefix = {
          [ESalesChannelRadioType.FROM_ANY_SELECTED]: getI18n(
            'customerList.registeredSalesChannel.isanyof',
          ),
          [ESalesChannelRadioType.NOT_FROM_ANY_SELECTED]: getI18n(
            'customerList.registeredSalesChannel.notanyof',
          ),
        };
        const textGenerator = () => {
          if (hasData) {
            return `${prefix[hasData] || ''} (${selectPromotion.join(',')})`;
          }
          return '';
        };
        return (
          <Co
            header={
              <div>
                {title ||
                  getI18n(
                    'customerList.registeredSalesChannel.registeredsaleschannel',
                  )}
              </div>
            }
            displayText={textGenerator()}
            hasData={hasData}
            onClose={handleOnClose}
            onClear={() => {
              //  console.log('name', name);
              form.setFieldsValue(defaultState);
            }}>
            <RegisteredSalesChannel
              {...rest}
              name={name}
              radioName={radioName}
              options={options}
              rules={[
                {
                  required: true,
                  message: getI18n(
                    'customerList.registeredSalesChannel.selectone',
                  ),
                },
              ]}
            />
          </Co>
        );
      }}
    </Item>
  );
};
export default _RegisteredSalesChannel;
